import React from "react";
import SelectPaymentRecordStatusModal from "../SelectPaymentRecordStatusModal/SelectPaymentRecordStatusModal";
import { getNormalizeDate } from "../../../../helpers";
import css from "./PaymentHistoryRow.module.css";
import parentCss from "../OrderDetailsLeft/OrderDetailsLeft.module.css";

const PaymentHistoryRow = ({ payment, orderId }) => {
  if (!payment) return null;

  const { id, amount, paymentMethod, paymentStatus, createdAt } = payment;

  const formatted = getNormalizeDate(createdAt);

  return (
    <div className={css.paymentRow}>
      <div className={parentCss.createdAt}>{formatted}</div>
      <div className={parentCss.amount}>{amount}</div>
      <div className={parentCss.paymentMethod}>{paymentMethod}</div>
      <div className={parentCss.paymentStatus}>
        <SelectPaymentRecordStatusModal
          key={`payment-status-${id}`}
          paymentStatus={paymentStatus}
          orderId={orderId}
          paymentId={id}
        />
      </div>
    </div>
  );
};

export { PaymentHistoryRow };

